import * as React from 'react';
import { SyntheticEvent } from 'react';
import InputMask from 'react-input-mask';

interface Props {
    labelProps: {
        labelText?: string;
        invalidText?: string;
        removeBoldFont?: boolean;
    };
    inputProps: {
        id: string;
        type?: string;
        name: string;
        placeholder?: string;
        required?: boolean;
        readOnly?: boolean;
        value?: string | number;
        pattern?: string;
        mask?: string;
        minLength?: number;
        maxLength?: number;
        disabled?: boolean;
        min?: string;
        max?: string;
    };
    helpTextProps?: {
        helpText: string;
        helpTextClass?: string;
    };
    onChange: (inputName: string, newValue: string | number) => void;
    inline?: boolean;
    controlCssClass?: string;
}

const FormInput = (props: Props) => {
    const inputChanged = (e: SyntheticEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (!props.inputProps.readOnly) {
            props.onChange(props.inputProps.name, e.currentTarget.value);
        }
    };
    let additionalGroupClasses = `${props.controlCssClass || ''}${props.inline ? ' row' : ''}`;
    let label = (
        <label
            htmlFor={props.inputProps.id}
            className={`${props.labelProps.removeBoldFont ? '' : 'font-weight-bold'}${
                props.inline ? ' col' : ''
                }`}
        >
            {props.labelProps.labelText === null ||
                props.labelProps.labelText === undefined ||
                props.labelProps.labelText === '' ? (
                    <>&nbsp;</>
                ) : (
                    props.labelProps.labelText
                )}
        </label>
    );
    return (
        <div className={'form-group ' + additionalGroupClasses}>
            {props.labelProps.labelText && label}
            {/* Only use the InputMask component if a mask was specified */}
            {props.inputProps.mask ? (
                <InputMask
                    {...props.inputProps}
                    onChange={inputChanged}
                    className={`form-control${props.inline ? ' col' : ''}`}
                    autoComplete="arbitrary-text"
                />
            ) : props.inputProps.type === 'textarea' ? (
                <textarea
                    {...props.inputProps}
                    onChange={inputChanged}
                    value={props.inputProps.value || ''}
                    className={`form-control${props.inline ? ' col' : ''}`}
                    readOnly={props.inputProps.readOnly} 
                />
            ) : (
                        <input
                            {...props.inputProps}
                            pattern={props.inputProps.type === 'email' ? '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$' : props.inputProps.pattern}
                            onChange={inputChanged}
                            value={props.inputProps.value || ''}
                            className={`form-control${props.inline ? ' col' : ''}`}
                            readOnly={props.inputProps.readOnly} 
                        />
                    )}
            {props.helpTextProps && (
                <small className={props.helpTextProps.helpTextClass || 'form-text text-muted'}>
                    {props.helpTextProps.helpText}
                </small>
            )}
            {props.labelProps.invalidText && (
                <div className="invalid-feedback">{props.labelProps.invalidText}</div>
            )}
        </div>
    );
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/common/form/Input.tsx